





































































import merge from "lodash/merge";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DealListPageQuery } from "../../DealList/queries/_build_documents_list";
import { ServerResult } from "../../../core/http/server_result";

export const ITEMS_LIST = "ITEMS_LIST";

@Component
export default class ClientChildrenList extends Vue {
  @Prop() clientId!: string;
  @Prop() clientData!: any;

  tableParams = {};
  documents = [];
  loading = false;
  lastMeta = {};
  selectedView = "head";

  get defaultSort() {
    return [
      this.$route.query.sortField || "name",
      this.$route.query.sortDirection || "desc"
    ];
  }

  onSort(field: string, direction: string) {
    console.log("onSort", field, direction);
    // tableParams
    this.tableParams = merge(this.tableParams, {
      sortField: field,
      sortDirection: direction
    });

    this.loadData();
  }

  private delayFilter: any = null;
  private delayFilterValue: any = null;

  onSearch(filter: string, value: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.tableParams = merge(this.tableParams, {
          [this.delayFilter]: this.delayFilterValue
        });
        this.delayFilter = null;
      }, 3000);
    }
    this.delayFilter = filter;
    this.delayFilterValue = value;
    this.loadData();
  }

  onPageChange(page: string) {
    console.log("onPageChange", page);
    this.tableParams = merge(this.tableParams, {
      page
    });

    this.loadData();
  }

  @Watch("selectedView")
  loadData() {
    this.loading = true;

    (this as any)
      .$db([
        (this as any)
          .$q(ITEMS_LIST)
          .raw("documents.list")
          .action({
            columns: {
              id: "c.id",
              name: "c.name"
            },
            from: "s:clients",
            from_as: "c",
            page_size: 10000,
            where: {
              $eq: [`c.${this.selectedView}_id`, { $: this.clientId }]
            }
          })
      ])
      .then((result: ServerResult) => {
        const opResult = result.getOperation(ITEMS_LIST).getContent();

        this.documents = opResult.documents;
        this.lastMeta = opResult.meta;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any) {
    this.$router.replace({
      name: "client-details",
      params: {
        id: row.id
      }
    });
  }

  // ---------------------------------------------------------------------------

  mounted() {
    this.loadData();
  }
}
